export default __webpack_public_path__ + "static/media/background-decoration_dots.02cdb8eb.svg";